var staticStrLast = 'last'

module.exports = staticStrLast



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/static/staticStrLast.js
// module id = 189
// module chunks = 106